export enum ORDER_STATE {
  PRE_CREATED = "PRE_CREATED",
  CREATED = "CREATED",
  IN_PROGRESS = "IN_PROGRESS",
  LOGISTIC_IN_PROGRESS = "LOGISTIC_IN_PROGRESS",
  FINISHED = "FINISHED",
  REFUSED = "REFUSED",
  CANCELLED = "CANCELLED",
  ERROR = "ERROR",
}

export enum ORDER_SUBSTATE {
  CREATED = "CREATED",
  PAYMENT_PROVIDER_SELECTED = "PAYMENT_PROVIDER_SELECTED",
  PAYMENT_ERROR = "PAYMENT_ERROR",
  DELIVERY_STORE = "DELIVERY_STORE",
  LOGISTIC_IN_PROGRESS = "LOGISTIC_IN_PROGRESS",
  PACKAGED = "PACKAGED",
  CANCELLED = "CANCELLED",
  FINISHED = "FINISHED",
}

export type ORDER_STATE_TAGS = {
  CREATED?: boolean;
  PAYED?: boolean;
  NOTPAYED?: boolean;
  PICKUP_PACKED?: boolean;
  PICKUP_NOTPACKED?: boolean;
  SEND?: boolean;
  WITHOUT_SEND?: boolean;
  FINISHED?: boolean;
  PENDING_REVIEW?: boolean;
  CANCELLED?: boolean;
};

export enum ORDER_STATE_CHANGE {
  NOTPAYED,
  PAYED,
  PACKAGED,
  SENDED,
  DELIVERED,
  CANCELLED,
}
